import React from 'react';

import PropTypes from 'prop-types';

import ColorPicker from 'components/modules/colors/components/ColorPaletteSelection/components/ColorPicker';
import { getColorString } from 'components/modules/colors/components/ColorPaletteSelection/components/ColorPicker/ColorPicker.utils';
import { shouldHideColorPicker } from 'components/modules/colors/services/colors';
import PaddingInput from 'components/modules/fields/components/PaddingInput';
import { shouldShowSizeInput } from 'components/modules/fields/services/size';
import { COLOR_UNIT, SIZE_UNIT } from 'components/modules/style-rules/constants';
import { StyleRuleConfigurationPropType } from 'components/modules/style-rules/types';

import './SpecialEditField.scss';

const propTypes = {
  styleRuleConfiguration: StyleRuleConfigurationPropType.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const defaultProps = {
  value: '',
  disabled: false,
};

export default function SpecialEditField({ styleRuleConfiguration, value, onChange, disabled }) {
  const { unit } = styleRuleConfiguration || {};

  const isColor = unit === COLOR_UNIT;
  const isSize = unit === SIZE_UNIT;

  if (isColor && !shouldHideColorPicker(getColorString(value))) {
    return (
      <ColorPicker
        withPopUpWrapper
        color={{ hex: value }}
        onSelect={(newColor) => {
          onChange({}, { name: 'value', value: getColorString(newColor) });
        }}
        disabled={disabled}
      />
    );
  }

  if (isSize && shouldShowSizeInput(value)) {
    const pixelsValue = +value.replace('px', '');

    return (
      <PaddingInput
        padding={pixelsValue}
        onChange={(newValue) => {
          onChange({}, { name: 'value', value: `${newValue}px` });
        }}
        hideLabel
        minPaddingAllowed={-500}
        maxPaddingAllowed={500}
        disabled={disabled}
      />
    );
  }

  return null;
}

SpecialEditField.propTypes = propTypes;
SpecialEditField.defaultProps = defaultProps;
